import React from "react";
import { Container } from "react-bootstrap";
import LiveSubscriptionStructure from "../../components/live-subscriptions/live-subs/LiveSubscriptionStructure";
import "../../styles/live-subscriptions/live-subscriptions.css";
import { selectUser } from "../../components/auth/auth.selector";
import { useSelector } from "react-redux";
import HelmetWrapper from "../../HelmetWrapper";

const LiveSubsciptions = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Live Subscriptions">
      <Container className="bg-cloud-k px-50px" fluid>
        <LiveSubscriptionStructure userInfoData={userInfoData} />;
      </Container>
    </HelmetWrapper>
  );
};

export default LiveSubsciptions;
